import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { EmailInput } from 'page/ProfileScreen/Email/EmailInput'
import { store } from 'store/store'

export const EmailForm = observer(() => {
  return <Vertical>
    <Typo size={12} secondary>{i18n('EmailLabel')}</Typo>
    <Gap height={12} />
    <EmailInput it={store.profile.email} />
  </Vertical>
})
